export default {"src":"/_next/static/media/change-cover.db6fc541.svg","height":280,"width":279,"blurWidth":0,"blurHeight":0};